// extracted by mini-css-extract-plugin
module.exports = {"AccordionPanel__collapseSection":"Accordion_AccordionPanel__collapseSection__iG6bY"};